if (!customElements.get('ingredients-cards-list')) {
  customElements.define(
    'ingredients-cards-list',
    class IngredientsCardsList extends HTMLElement {
      connectedCallback() {
        this._swiper = null;
        this._cardsClickTarget = null;
        this._onCardsClick = this._onCardsClick.bind(this);
        this._mq = window.matchMedia('(max-width: 767px)');
        this._onChange = this._onChange.bind(this);
        this._mq.addEventListener('change', this._onChange);

        if (this._mq.matches) {
          this._initSwiper();
        } else {
          this._resetLayout();
        }
      }

      disconnectedCallback() {
        this._mq.removeEventListener('change', this._onChange);
        this._destroySwiper();
      }

      _onChange(event) {
        if (event.matches) {
          this._initSwiper();
        } else {
          this._destroySwiper();
          this._resetLayout();
        }
      }

      _calcSlidesOffsetAfter(width) {
        const slidesPerView = 1.12;
        const spaceBetween = 12;
        const slideWidth = (width - spaceBetween * (slidesPerView - 1)) / slidesPerView;

        return Math.floor(width - slideWidth);
      }

      _initSwiper() {
        if (this._swiper || !this._mq.matches) return;

        const init = () => {
          if (typeof Swiper === 'undefined') return;

          const el = this.querySelector('.section-ingredients__cards-swiper');
          const pagination = this.querySelector('.section-ingredients__cards-pagination');
          if (!el || this._swiper) return;

          const slidesOffsetAfter = this._calcSlidesOffsetAfter(el.clientWidth);

          this._cardsClickTarget = el;
          el.addEventListener('click', this._onCardsClick);

          this._swiper = new Swiper(el, {
            slideClass: 'shopify-block',
            slidesPerView: 1.12,
            spaceBetween: 12,
            slidesOffsetAfter,
            slideToClickedSlide: true,
            watchOverflow: true,
            pagination: pagination
              ? {
                  el: pagination,
                  clickable: true,
                }
              : false,
            on: {
              resize: (swiper) => {
                const offsetAfter = this._calcSlidesOffsetAfter(swiper.width);

                if (swiper.params.slidesOffsetAfter !== offsetAfter) {
                  swiper.params.slidesOffsetAfter = offsetAfter;
                  swiper.update();
                }
              },
            },
          });
        };

        if (typeof Swiper !== 'undefined') {
          init();
        } else {
          setTimeout(init, 300);
        }
      }

      _onCardsClick(event) {
        if (!this._swiper) return;

        const el = this._cardsClickTarget;
        const slide = event.target.closest('.shopify-block');
        if (!slide || !el?.contains(slide)) return;

        const slides = [...el.querySelectorAll('.swiper-wrapper > .shopify-block')];
        const index = slides.indexOf(slide);
        if (index === -1 || index === this._swiper.activeIndex) return;

        this._swiper.slideTo(index);
      }

      _destroySwiper() {
        if (!this._swiper) return;

        this._cardsClickTarget?.removeEventListener('click', this._onCardsClick);
        this._cardsClickTarget = null;
        this._swiper.destroy(true, true);
        this._swiper = null;
        this._resetLayout();
      }

      _resetLayout() {
        const wrapper = this.querySelector('.section-ingredients__cards-swiper > .swiper-wrapper');
        const slides = this.querySelectorAll(
          '.section-ingredients__cards-swiper > .swiper-wrapper > .shopify-block'
        );

        wrapper?.removeAttribute('style');
        slides.forEach((slide) => slide.removeAttribute('style'));
      }
    }
  );
}
